import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class ProductPrice extends Component {
  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section, dialog');
    if (section) section.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const section = this.closest('.shopify-section, dialog');
    if (section) section.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise.then(({ detail }) => {
      if (!detail?.html) return;
      const { html, newProduct } = detail;

      if (newProduct) this.dataset.productId = newProduct.id;
      else if (detail.productId && detail.productId !== this.dataset.productId) return;

      const { priceContainer, volumePricingNote } = this.refs;
      const newProductPrice = html.querySelector(`product-price[data-block-id="${this.dataset.blockId}"]`);
      if (!newProductPrice) return;

      const newPrice = newProductPrice.querySelector('[ref="priceContainer"]');
      if (newPrice && priceContainer) priceContainer.replaceWith(newPrice);

      const newNote = newProductPrice.querySelector('[ref="volumePricingNote"]');
      if (!newNote) volumePricingNote?.remove();
      else if (!volumePricingNote) newPrice?.insertAdjacentElement('afterend', newNote.cloneNode(true));
      else volumePricingNote.replaceWith(newNote);

      const installmentsInput = this.querySelector(`#product-form-installment-${this.dataset.blockId} input[name="id"]`);
      if (installmentsInput) {
        installmentsInput.value = detail.resource?.id ?? '';
        installmentsInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[product-price] Event promise rejected:', error);
    });
  };
}

if (!customElements.get('product-price')) customElements.define('product-price', ProductPrice);

const syncTflMomentPrices = (moment) => {
  const select = moment.querySelector('[data-variant]');
  if (!(select instanceof HTMLSelectElement)) return;

  const fields = [...moment.querySelectorAll('[data-option-position]')];
  const momentField = fields.find((field) => field.classList.contains('tfl-moment__option--full-moment'));
  if (!momentField) return;

  const momentIndex = fields.indexOf(momentField);
  let fallback = [];
  try { fallback = JSON.parse(select.options[select.selectedIndex]?.dataset.options || '[]'); } catch {}

  const chosen = fields.map((field, index) =>
    field.querySelector('[data-value][aria-pressed="true"]')?.dataset.value || fallback[index] || ''
  );

  const variants = [...select.options].map((option) => {
    let values = [];
    try { values = JSON.parse(option.dataset.options || '[]'); } catch {}
    return { values, price: option.dataset.price || '' };
  });

  momentField.querySelectorAll('[data-value]').forEach((choice) => {
    const wanted = [...chosen];
    wanted[momentIndex] = choice.dataset.value || '';
    const match = variants.find((variant) =>
      variant.values.length === wanted.length &&
      variant.values.every((value, index) => String(value) === String(wanted[index]))
    );
    const price = choice.querySelector('.tfl-moment__moment-price');
    if (price && match?.price) price.textContent = match.price;
  });
};

const initTflMomentPrices = () => {
  document.querySelectorAll('tfl-moment').forEach((moment) => {
    if (moment.dataset.tflMomentPrices === 'ready') return;
    moment.dataset.tflMomentPrices = 'ready';

    let frame;
    const sync = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => syncTflMomentPrices(moment));
    };

    new MutationObserver(sync).observe(moment, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-pressed']
    });

    moment.addEventListener('click', () => {
      setTimeout(sync, 0);
      setTimeout(sync, 80);
    });

    sync();
    setTimeout(sync, 100);
  });
};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTflMomentPrices, { once: true });
else initTflMomentPrices();
document.addEventListener('shopify:section:load', initTflMomentPrices);
